import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Zm1.25 0a8.75 8.75 0 1 1-17.5 0 8.75 8.75 0 0 1 17.5 0Zm-6.201-.625L10.093 6.92l.884-.884L14.5 9.559a.625.625 0 0 1 0 .883l-3.52 3.52-.883-.884 2.452-2.452H5.452v-1.25h7.097Z",
      fill: "currentcolor"
    }, null, -1)
  ])))
}
export default { render: render }